// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"d75e7a89","527":"423246e6","787":"d4aba7ab","791":"19fe9650","792":"7f98c089"}[chunkId] + ".chunk.js";
};